import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { pspDemo, pspProd } from '../../shared/functions/wallets.js';

import { PaymentHistoryRequest } from 'src/app/core/models/request/payment-history.request';
import { SessionCacheModel } from 'src/app/core/models/session-cache.model';
import { IdentityService } from 'src/app/core/services/identity.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { PaymentIconsService } from 'src/app/core/services/payment-icons.service';
import { PaymentsService } from 'src/app/core/services/payments.service';
import { SessionCacheService } from 'src/app/core/services/session-cache.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { UserService } from 'src/app/core/services/user.services';
import { dateFormatNotHour } from 'src/app/shared/functions/date.functions';
import { AppIcon } from 'src/app/shared/interfaces/app-icon';
import { IOptionsNgSelect } from 'src/app/shared/interfaces/ioptionsNgSelect';
import { environment as cenv } from 'src/environments/environment';
import { environment as denv } from 'src/environments/environment.demo';
import { DetailPaymentService } from '../detail-pay/services/detail.payment.service';
import { BranchOfficeModel } from 'src/app/core/models/branch-office.model';
import { PrintCloverTicketService } from '../../core/services/print-clover-ticket.service';
import { CierreLotePopupComponent } from './components/cierre-lote-popup/cierre-lote-popup.component';
import { CloverService } from 'src/app/core/services/clover.service';
import { DescargarLiquidacionPopupComponent } from './components/descargar-liquidacion-popup/descargar-liquidacion-popup.component';
import { NativeBridgeService } from 'src/app/core/services/native-bridge.service';
import { deviceEnvironmentId } from 'src/app/core/enums/device-environment-id';
import { ConfirmarDialogComponent } from 'src/app/shared/components/confirmar-dialog/confirmar-dialog.component';
import { DialogAfipComponent } from 'src/app/shared/components/dialog-afip/dialog-afip.component';
import { TipoMedioPagoEnum } from 'src/app/core/enums/tipo-medio-pago.enum.js';
import { runtimeEnv } from 'src/environments/env-loader';

@Component({
  selector: 'app-table-movements',
  templateUrl: './table-movements.component.html',
  styleUrls: ['./table-movements.component.scss']
})
export class TableMovementsComponent implements OnInit {
  readonly MOVEMENTS: string = 'maximized';
  private readonly BRANCHS: string = 'branchs';
  private readonly TO_MILISECONDS: number = runtimeEnv.THROTTLEDREFRESHBALANCE * 6000;
  private readonly CURRENT_ENV = cenv.apiURL;
  private readonly DEMO_ENV = denv.apiURL;

  downloadLoading = false;

  constructor(
    public dialog: MatDialog,
    private paymentsService: PaymentsService,
    private storage: StorageService,
    private translateService: TranslateService,
    private paymentIconsService: PaymentIconsService,
    private notificationService: NotificationService,
    private identity: IdentityService,
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private detailStorage: DetailPaymentService,
    private sessionCacheService: SessionCacheService,
    private printCloverTicketService: PrintCloverTicketService,
    private cloverService: CloverService,
    private nativeBridgeService: NativeBridgeService
  ) {
    this.route.queryParams.subscribe((queryParams) => {
      this.currentPage = queryParams['page'];
      this.setFiltersFromParams(queryParams);
    });

    this.environment = this.storage.get('appEnvironment');
  }

  search = new UntypedFormControl('');
  loading: boolean = true;
  loadingExcel: boolean = false;
  totalSize: any = 0;
  filter: string = '';
  filterFormValues: FilterValues = {
    paymentMethods: [],
    paymentStates: [],
    dateFrom: this.getDefaultDateFrom(),
    hourFrom: '00',
    minutesFrom: '00',
    dateTo: this.getDefaultDateTo(),
    hourTo: '23',
    minutesTo: '59',
    branches: [],
    cashiers: []
  };
  refreshDates: boolean = false;

  filterMovs: any;
  paymentMethodCollection: IOptionsNgSelect[];
  branchOfficesCollection: IOptionsNgSelect[];
  branchsObject: BranchOfficeModel[];
  cashiersObject: any[] = new Array<any>();

  movimientosList: any;
  noMovements: boolean = false;
  currentPage: number;

  branchCollection: any[];
  cashierCollection: IOptionsNgSelect[];
  branchFilter: IOptionsNgSelect[];
  cashierFilter: IOptionsNgSelect[];
  commerceUser: boolean = true;
  userResponsible: boolean = true;
  disabledPicker: boolean = true;
  expandSearch: boolean = false;
  bounceSearch: boolean;
  inputFindEventHandler: Subject<string>;
  defaultIdPaymentMethods = [30, 42];

  showOptions = false;
  isClover: boolean = false;
  environment: string;
  isDefaultDateRange: boolean = true;
  dateRangeText: string = '';
  showDefaultRangeBanner: boolean = true;

  estadoSelect = [
    { estado: 'Todos' },
    { estado: 'Confirmado', value: 'Confirmado' },
    { estado: 'Acreditado', value: 'Acreditado' },
    { estado: 'Aprobado', value: 'Aprobado' },
    { estado: 'Pendiente', value: 'Pendiente' },
    { estado: 'Anulado', value: 'Anulado' },
    { estado: 'Rechazado', value: 'Rechazado' }
  ];

  estadoDelPago: Array<IOptionsNgSelect>;

  estadoDelPagoTransferencia: Array<IOptionsNgSelect> = [
    { value: 4, display: 'constants.payment_status.c', type: 'C' },
    { value: 5, display: 'constants.payment_status.r', type: 'R' },
    { value: 3, display: 'constants.payment_status.p', type: 'P' }
  ] as IOptionsNgSelect[];

  estadoDelPagoPCT: Array<IOptionsNgSelect>;

  stateList: Array<IOptionsNgSelect> | undefined;

  async ngOnInit() {
    this.estadoDelPago = [
      { value: 1, display: this.translate('constants.payment_status.d'), type: 'D' },
      { value: 2, display: this.translate('constants.payment_status.a'), type: 'A' },
      { value: 3, display: this.translate('constants.payment_status.p'), type: 'P' },
      { value: 4, display: this.translate('constants.payment_status.c'), type: 'C' },
      { value: 5, display: this.translate('constants.payment_status.r'), type: 'R' },
      { value: 6, display: this.translate('constants.payment_status.n'), type: 'N' },
      { value: 7, display: this.translate('constants.payment_status.u'), type: 'U' },
      { value: 8, display: this.translate('constants.payment_status.e'), type: 'E' }
    ] as IOptionsNgSelect[];
    this.estadoDelPagoPCT = [
      { value: 2, display: 'constants.payment_status.a', type: 'A' },
      { value: 5, display: 'constants.payment_status.r', type: 'R' },
      { value: 3, display: 'constants.payment_status.p', type: 'P' }
    ] as IOptionsNgSelect[];
    this.stateList = [
      { value: 3, display: 'constants.payment_status.p', type: 'P' },
      { value: 5, display: 'constants.payment_status.r', type: 'R' }
    ];

    this.isClover = this.nativeBridgeService.getEnvironment() === deviceEnvironmentId.CLOVER;
    this.commerceUser = this.identity.isCommerce();
    this.userResponsible = this.identity.isRolResponsible();
    this.commerceUser || this.userResponsible ? this.LoadCommerce() : await this.loadPaymentMethodCollection();

    if (this.detailStorage.hasFilterValues()) {
      this.setFiltros();
    } else {
      // Establecer fechas por defecto directamente en detailStorage
      this.detailStorage.movementFilters.dateFrom = this.getDefaultDateFrom();
      this.detailStorage.movementFilters.dateTo = this.getDefaultDateTo();
      this.detailStorage.movementFilters.hourFrom = '00';
      this.detailStorage.movementFilters.minutesFrom = '00';
      this.detailStorage.movementFilters.hourTo = '23';
      this.detailStorage.movementFilters.minutesTo = '59';

      // Actualizar filterFormValues para mantener sincronización
      this.filterFormValues.dateFrom = this.detailStorage.movementFilters.dateFrom;
      this.filterFormValues.dateTo = this.detailStorage.movementFilters.dateTo;

      this.getMovementsWithFilters(true);
    }

    this.search.valueChanges.pipe(debounceTime(50)).subscribe((value: string) => {
      this.filter = value;
    });
  }

  handleFilterMovementsEvent(handleFilterMovementsEvent?: FilterValues) {
    this.showOptions = false;
    this.filterFormValues = handleFilterMovementsEvent;
    this.saveMovementFilters();
    this.currentPage = 0;

    // Actualizar leyenda solo cuando se aplica el filtro
    const dateFrom = handleFilterMovementsEvent?.dateFrom || this.getDefaultDateFrom();
    const dateTo = handleFilterMovementsEvent?.dateTo || this.getDefaultDateTo();

    // Verificar si es el rango por defecto
    const defaultFrom = this.getDefaultDateFrom();
    const defaultTo = this.getDefaultDateTo();
    const isDefault = this.isSameDay(dateFrom, defaultFrom) && this.isSameDay(dateTo, defaultTo);

    this.isDefaultDateRange = isDefault;
    this.showDefaultRangeBanner = isDefault;
    this.dateRangeText = this.formatDateRange(dateFrom, dateTo);

    this.getMovementsWithFilters(true);
  }

  handleDateRangeChanged(event: any) {
    // Solo actualizar el estado del banner, no la leyenda
    this.showDefaultRangeBanner = event.isDefault;
  }

  private isSameDay(date1: Date, date2: Date): boolean {
    const d1 = new Date(date1);
    const d2 = new Date(date2);
    return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
  }

  formatDateRange(dateFrom: Date, dateTo: Date): string {
    const formatDate = (date: Date): string => {
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();
      return `${day}/${month}/${year}`;
    };

    return `${formatDate(dateFrom)} - ${formatDate(dateTo)}`;
  }

  private getDefaultDateFrom(): Date {
    const date = new Date();
    date.setDate(date.getDate() - 31);
    return date;
  }

  private getDefaultDateTo(): Date {
    return new Date();
  }

  buildCashierSelect(branchesSelected: any[]) {
    this.cashiersObject = [];
    if (this.branchsObject) {
      this.branchsObject.forEach((ob) => {
        const selectedBranches = branchesSelected || [];
        if (selectedBranches.includes(ob.id)) {
          ob.cashiers.forEach((cashier) => {
            if (!this.cashiersObject.some((obj) => obj.id === cashier.id)) {
              this.cashiersObject.push(cashier);
            }
          });
        }
      });
    }

    this.cashierCollection = this.cashiersObject.map((ob) => {
      return {
        value: ob.id,
        display: ob.nombre,
        type: ob.nombre
      } as IOptionsNgSelect;
    });

    this.cashierFilter = this.cashierCollection;
  }

  async handleClick() {
    this.showOptions = false;
    await this.getDataGrid(this.currentPage);
  }

  async LoadCommerce() {
    await this.loadbranchOffices();
    await this.loadPaymentMethodCollection();
  }

  private async loadbranchOffices() {
    this.sessionCacheService.expiredData(this.BRANCHS);
    !this.sessionCacheService.getData(this.BRANCHS) ? await this.saveBranchsInCache() : this.getBranchInCache();
  }

  async saveBranchsInCache() {
    let cache = new SessionCacheModel();
    this.branchOfficesCollection = Array<IOptionsNgSelect>();
    let officeBranches = await this.userService.getBranchOfficesCollection();
    this.branchsObject = officeBranches;
    officeBranches.forEach((ob) => {
      const opt = { value: ob.id, display: ob.name, type: ob.name };
      this.branchOfficesCollection.push(opt as IOptionsNgSelect);
    });
    this.branchFilter = this.branchOfficesCollection;
    cache.data = officeBranches;
    cache.iat = +new Date() + this.TO_MILISECONDS;
    this.sessionCacheService.saveDataWithExpiration(this.BRANCHS, cache);
  }

  getBranchInCache() {
    let officeBranches = JSON.parse(this.sessionCacheService.getData(this.BRANCHS)).data;
    this.branchsObject = officeBranches;
    this.branchOfficesCollection = Array<IOptionsNgSelect>();
    officeBranches.forEach((ob) => {
      const opt = { value: ob.id, display: ob.name, type: ob.name };
      this.branchOfficesCollection.push(opt as IOptionsNgSelect);
    });
    this.branchFilter = this.branchOfficesCollection;
  }

  viewDetail(data) {
    this.detailStorage.currentTableMovementPage = this.currentPage;
    this.router.navigate(['/user/movements/detail'], {
      queryParams: { page: this.detailStorage.currentTableMovementPage, operationId: data.id }
    });
  }

  private async loadPaymentMethodCollection() {
    try {
      const response = await this.userService.getPaymentMethodCollection();
      const allowedValues = [30, 42];

      this.paymentMethodCollection = response
        .filter((ob) => allowedValues.includes(ob.id))
        .map((ob) => ({
          value: ob.id,
          display: ob.descripcion,
          type: ob.nombre
        }));
    } catch (error) {
      this.notificationService.showError('Error al obtener medios de pago');
    }
  }

  maskPrice(price: string) {
    if (price.startsWith('-')) {
      let importe = price.slice(1);
      return `-$${importe}`;
    } else {
      return `$${price}`;
    }
  }

  maskCuit(cuit: string): string {
    return cuit.length > 8
      ? `${cuit.substring(0, 2)}-${cuit.substring(2, 10)}-${cuit.substring(10, 11)}`
      : `${cuit.substring(0, 2)}.${cuit.substring(2, 5)}.${cuit.substring(5, 8)}`;
  }

  isDemo(): boolean {
    return this.CURRENT_ENV == this.DEMO_ENV ? true : false;
  }

  isPSP(billetera): boolean {
    return billetera !== null ? (billetera.length == 4 ? true : false) : false;
  }

  getWalletDom(wallet): string {
    return this.isDemo() ? pspDemo[wallet] : pspProd[wallet];
  }

  getWallet(mov): AppIcon {
    let psp = mov.cvuContraparte ? mov.cvuContraparte.slice(3, 7) : '';
    return mov.billetera == null
      ? this.paymentIconsService.getIcon(mov.medioPagoView, this.getWalletDom(psp), mov.conceptoTipo)
      : mov.billetera !== null && this.isPSP(mov.billetera)
      ? this.paymentIconsService.getIcon(mov.medioPagoView, this.getWalletDom(mov.billetera), mov.conceptoTipo)
      : mov.billetera !== null && !this.isPSP(mov.billetera)
      ? this.paymentIconsService.getIcon(mov.medioPagoView, mov.billetera, mov.conceptoTipo)
      : null;
  }

  getIcon(mov): AppIcon {
    return mov.medioPagoView == 'PCT'
      ? this.getWallet(mov)
      : this.paymentIconsService.getIcon(mov.medioPagoView, mov.billetera, mov.conceptoTipo);
  }

  setClassEstado(estado: string) {
    if (estado == 'Confirmado') return 'confirmado';
    else if (estado == 'Acreditado') return 'acreditado';
    else if (estado == 'Aprobado') return 'confirmado';
    else if (estado == 'Pendiente') return 'pendiente';
    else if (estado == 'Anulado') return 'anulado';
    else return 'error';
  }

  async nextPage() {
    await this.getDataGrid(this.currentPage);
    const queryParams = { page: this.currentPage };

    this.router.navigate([], {
      queryParams,
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }

  async getDataGrid(page?: number) {
    const request = page ? this.createRequest(false, page) : this.createRequest();
    this.sessionCacheService.expiredData(this.MOVEMENTS);
    await this.cargarMovimientos(request).catch((error) => {
      this.loading = false;
    });
  }

  async cargarMovimientos(request, isFilter?: boolean) {
    this.loading = true;
    this.filterMovs = [];
    if (this.identity.getUser().isResponsible) {
      const branchsIdsArray = await this.userService.getBranchOfficesCollection();
      request.idsSucursales = branchsIdsArray.map((branch) => branch.id);
    }
    let cached = this.sessionCacheService.getData(this.MOVEMENTS);
    if (this.currentPage <= 1 && cached && !isFilter) {
      const movimientos = JSON.parse(cached).data;
      this.totalSize = movimientos.size;
      this.movimientosList = movimientos.list;
      this.filterMovs = this.movimientosList;
    } else if (this.currentPage <= 1 && !cached && !isFilter) {
      const movimientos = await this.paymentsService.getPaymentHistory(request);
      let cache = new SessionCacheModel();
      cache.data = movimientos;
      cache.iat = +new Date() + runtimeEnv.THROTTLEDREFRESHBALANCE * 1000;
      this.sessionCacheService.saveDataWithExpiration(this.MOVEMENTS, cache);
      this.totalSize = movimientos.size;
      this.movimientosList = movimientos.list;
      this.filterMovs = this.movimientosList;
    } else {
      const movimientos = await this.paymentsService.getPaymentHistory(request);
      this.totalSize = movimientos.size;
      this.movimientosList = movimientos.list;
      this.filterMovs = this.movimientosList;
    }
    this.loading = false;
  }

  async getMovementsWithFilters(filter?: boolean) {
    this.totalSize = 0;
    let request = this.createRequest(false, 0);
    await this.cargarMovimientos(request, filter).catch((error) => {
      this.loading = false;
    });
  }

  async cleanFilters(newFormValue: FilterValues) {
    this.showOptions = false;
    //search
    if (this.search.value !== '') {
      this.search.setValue('');
      this.filter = '';
    }

    // Asegurarse de que las fechas estén establecidas al rango por defecto
    if (!newFormValue.dateFrom || !newFormValue.dateTo) {
      newFormValue.dateFrom = this.getDefaultDateFrom();
      newFormValue.dateTo = this.getDefaultDateTo();
      newFormValue.hourFrom = '00';
      newFormValue.minutesFrom = '00';
      newFormValue.hourTo = '23';
      newFormValue.minutesTo = '59';
    }

    this.filterFormValues = newFormValue;

    // Establecer directamente en detailStorage con fechas por defecto
    this.detailStorage.movementFilters.dateFrom = newFormValue.dateFrom;
    this.detailStorage.movementFilters.dateTo = newFormValue.dateTo;
    this.detailStorage.movementFilters.hourFrom = newFormValue.hourFrom;
    this.detailStorage.movementFilters.minutesFrom = newFormValue.minutesFrom;
    this.detailStorage.movementFilters.hourTo = newFormValue.hourTo;
    this.detailStorage.movementFilters.minutesTo = newFormValue.minutesTo;
    this.detailStorage.movementFilters.currentMethods = null;
    this.detailStorage.movementFilters.currentStates = null;
    this.detailStorage.movementFilters.currentBranches = null;
    this.detailStorage.movementFilters.currentCashiers = null;

    this.currentPage = 0;
    this.totalSize = 0;

    // Actualizar el estado del rango de fechas y leyenda cuando se limpian los filtros
    this.isDefaultDateRange = true;
    this.showDefaultRangeBanner = true;
    this.dateRangeText = this.formatDateRange(newFormValue.dateFrom, newFormValue.dateTo);

    this.getMovementsWithFilters(true);
  }

  setFiltros() {
    if (this.detailStorage.movementFilters.currentMethods?.length) {
      this.filterFormValues.paymentMethods = this.detailStorage.movementFilters.currentMethods;
      this.setStateList(this.filterFormValues.paymentMethods);
    }

    if (this.detailStorage.movementFilters.currentStates?.length) {
      this.filterFormValues.paymentStates = this.detailStorage.movementFilters.currentStates;
    }

    if (this.detailStorage.movementFilters.dateFrom) {
      this.filterFormValues.dateFrom = this.detailStorage.movementFilters.dateFrom;
    }

    if (this.detailStorage.movementFilters.dateTo) {
      this.filterFormValues.dateTo = this.detailStorage.movementFilters.dateTo;
    }

    if (this.detailStorage.movementFilters.currentBranches?.length) {
      this.filterFormValues.branches = this.detailStorage.movementFilters.currentBranches;
    }

    if (this.detailStorage.movementFilters.currentCashiers?.length) {
      this.filterFormValues.cashiers = this.detailStorage.movementFilters.currentCashiers;
    }

    this.getMovementsWithFilters(true);
  }

  handleKeyUp(key: any) {
    key.keyCode === 13 ? this.handleFilterMovementsEvent() : null;
  }

  private createRequest(allSize?: boolean, page?: number): PaymentHistoryRequest {
    let request = new PaymentHistoryRequest();
    if (allSize != undefined && allSize) {
      request.elements = this.totalSize;
      request.page = 0;
    } else {
      request.elements = 10;
      request.page = this.currentPage ? this.currentPage - 1 : 0;
      if (request.page == -1) request.page = 0;
    }

    if (this.detailStorage.movementFilters?.dateFrom && this.filterFormValues?.dateFrom) {
      request.fechaDesde = dateFormatNotHour(this.detailStorage.movementFilters?.dateFrom);
      request.horaDesde =
        this.detailStorage.movementFilters?.hourFrom + ':' + this.detailStorage.movementFilters?.minutesFrom;
    }
    request.estadosPago = new Array<string>();
    if (this.detailStorage.movementFilters?.dateTo && this.filterFormValues?.dateTo) {
      request.fechaHasta = dateFormatNotHour(this.filterFormValues?.dateTo);
      request.horaHasta =
        this.detailStorage.movementFilters?.hourTo + ':' + this.detailStorage.movementFilters?.minutesTo;
      if (this.detailStorage.movementFilters?.dateFrom > this.filterFormValues?.dateTo) {
        this.notificationService.mgsView({
          error: null,
          messenger: this.translate('pages.list_pay.messages.date_span_error'),
          title: this.translate('pages.list_pay.labels.movements'),
          type: 3,
          configNotification: null
        });
        return;
      }
    }

    if (this.filter !== '' && this.filter.length > 0) {
      request.filter = this.filter.trim();
    } else {
      request.filter = null;
    }

    if (
      this.detailStorage.movementFilters.currentStates &&
      this.detailStorage.movementFilters.currentStates?.length > 0
    ) {
      this.detailStorage.movementFilters.currentStates.forEach((element) => {
        request.estadosPago.push(this.estadoDelPago[+element - 1].type);
      });
    } else {
      this.estadoDelPago.forEach((element) => {
        request.estadosPago.push(element.type);
      });
    }

    if (
      this.detailStorage.movementFilters.currentBranches &&
      this.detailStorage.movementFilters.currentBranches.length > 0
    ) {
      request.idsSucursales = new Array<number>();
      this.detailStorage.movementFilters.currentBranches.forEach((element) => {
        request.idsSucursales.push(element);
      });
    }

    if (
      this.detailStorage.movementFilters.currentCashiers &&
      this.detailStorage.movementFilters.currentCashiers.length > 0
    ) {
      request.idsCashier = new Array<number>();
      this.detailStorage.movementFilters.currentCashiers.forEach((element) => {
        request.idsCashier.push(element);
      });
    }

    if (
      this.detailStorage.movementFilters.currentMethods &&
      this.detailStorage.movementFilters.currentMethods?.length > 0
    ) {
      request.idsPaymentMethods = new Array<number>();
      this.detailStorage.movementFilters.currentMethods.forEach((element) => {
        request.idsPaymentMethods.push(element);
      });
    } else {
      request.idsPaymentMethods = this.defaultIdPaymentMethods;
    }
    return request;
  }

  set inputFindModel(value: string) {
    this.bounceSearch = true;
    this.inputFindEventHandler.next(value);
  }

  onKey(event) {
    console.log(event);
  }

  expand() {
    this.expandSearch = true;
  }

  async excelExport(dateValues: any) {
    if (!dateValues?.dateFrom && !dateValues?.dateTo) {
      this.notificationService.mgsView({
        error: null,
        messenger: this.translate('pages.list_pay.messages.date_range'),
        title: this.translate('pages.list_pay.labels.movements'),
        type: 3,
        configNotification: null
      });
    } else {
      this.loadingExcel = true;
      const sucursalValue = dateValues.sucursales != undefined ? dateValues.sucursales : null;
      if (sucursalValue != null) {
        dateValues.sucursales = dateValues.sucursales
          .map((sucursal) => {
            if (typeof sucursal === 'object') {
              return JSON.stringify(sucursal.value);
            } else if (typeof sucursal === 'number') {
              return sucursal.toString();
            }
          })
          .join(',');
      }
      let request;
      if (this.identity.getUser().isResponsible) {
        request = {
          fechaDesde: dateFormatNotHour(dateValues?.dateFrom),
          fechaHasta: dateFormatNotHour(dateValues?.dateTo),
          email: this.identity.getUser().email,
          sucursales: dateValues.sucursales,
          usuarioId: this.identity.getUser().id
        };
      } else {
        if (dateValues.sucursalesSelect) {
          request = {
            fechaDesde: dateFormatNotHour(dateValues?.dateFrom),
            fechaHasta: dateFormatNotHour(dateValues?.dateTo),
            email: this.identity.getUser().email,
            sucursales: dateValues.sucursales,
            usuarioId: this.identity.getUser().id
          };
        } else {
          request = {
            fechaDesde: dateFormatNotHour(dateValues?.dateFrom),
            fechaHasta: dateFormatNotHour(dateValues?.dateTo),
            email: this.identity.getUser().email,
            sucursales: null,
            usuarioId: this.identity.getUser().id
          };
        }
      }

      await this.paymentsService
        .downloadExcel(request)
        .then((message) => {
          this.loadingExcel = false;
          if (message) {
            this.refreshDates = !this.refreshDates;
            this.dialog.open(DialogAfipComponent, {
              width: '600px',
              data: {
                error: message,
                title: 'Excel de liquidación'
              }
            });
          }
        })
        .catch((error) => {
          this.loadingExcel = false;
        });
    }
  }

  translate(key: string): string {
    return this.translateService.instant(key);
  }

  public setStateList(methodsSelected: any[]) {
    let tempArray = [
      { value: 3, display: 'constants.payment_status.p', type: 'P' },
      { value: 5, display: 'constants.payment_status.r', type: 'R' }
    ];
    methodsSelected.forEach((medio) => {
      switch (medio) {
        case 30:
          tempArray.push({ value: 2, display: 'constants.payment_status.a', type: 'A' });
          break;
        case 42:
          tempArray.push(
            { value: 2, display: 'constants.payment_status.a', type: 'A' },
            { value: 1, display: this.translate('constants.payment_status.d'), type: 'D' }
          );
          break;
        default:
          break;
      }
    });

    this.stateList = this.getUniqueValues(tempArray);
  }

  getUniqueValues(array: any[]) {
    return array.filter((obj, index, self) => index === self.findIndex((t) => t.value === obj.value));
  }

  setFiltersFromParams(queryParams: any) {
    if (queryParams?.paymentState && queryParams?.paymentState?.length) {
      this.detailStorage.movementFilters.currentStates == null
        ? (this.detailStorage.movementFilters.currentStates = queryParams?.paymentState?.map((el) => +el))
        : null;
    }

    if (queryParams?.methodParams?.length) {
      this.detailStorage.movementFilters.currentMethods == null
        ? (this.detailStorage.movementFilters.currentMethods = queryParams.methodParams.map((el) => +el))
        : null;
    }

    if (queryParams?.dateFrom) {
      this.detailStorage.movementFilters.dateFrom = new Date(queryParams.dateFrom);
    }

    if (queryParams?.dateTo) {
      this.detailStorage.movementFilters.dateTo = new Date(queryParams.dateTo);
    }

    if (queryParams?.accreditationDateFrom) {
      this.detailStorage.movementFilters.accreditationDateFrom = queryParams.accreditationDateFrom;
      this.detailStorage.movementFilters.dateFrom = null;
    }

    if (queryParams?.accreditationDateTo) {
      this.detailStorage.movementFilters.accreditationDateTo = queryParams.accreditationDateTo;
      this.detailStorage.movementFilters.dateTo = null;
    }
  }

  saveMovementFilters() {
    this.filterFormValues.paymentMethods?.length
      ? (this.detailStorage.movementFilters.currentMethods = this.filterFormValues.paymentMethods)
      : (this.detailStorage.movementFilters.currentMethods = null);

    this.filterFormValues.paymentStates?.length
      ? (this.detailStorage.movementFilters.currentStates = this.filterFormValues.paymentStates)
      : (this.detailStorage.movementFilters.currentStates = null);

    this.filterFormValues.branches?.length
      ? (this.detailStorage.movementFilters.currentBranches = this.filterFormValues.branches)
      : (this.detailStorage.movementFilters.currentBranches = null);

    this.filterFormValues.cashiers?.length
      ? (this.detailStorage.movementFilters.currentCashiers = this.filterFormValues.cashiers)
      : (this.detailStorage.movementFilters.currentCashiers = null);

    this.filterFormValues.dateFrom
      ? (this.detailStorage.movementFilters.dateFrom = this.filterFormValues.dateFrom)
      : (this.detailStorage.movementFilters.dateFrom = null);
    this.filterFormValues.hourFrom
      ? (this.detailStorage.movementFilters.hourFrom = this.filterFormValues.hourFrom)
      : (this.detailStorage.movementFilters.hourFrom = '00');

    this.filterFormValues.minutesFrom
      ? (this.detailStorage.movementFilters.minutesFrom = this.filterFormValues.minutesFrom)
      : (this.detailStorage.movementFilters.minutesFrom = '00');

    this.filterFormValues.dateTo
      ? (this.detailStorage.movementFilters.dateTo = this.filterFormValues.dateTo)
      : (this.detailStorage.movementFilters.dateTo = null);

    this.filterFormValues.hourTo
      ? (this.detailStorage.movementFilters.hourTo = this.filterFormValues.hourTo)
      : (this.detailStorage.movementFilters.hourTo = '23');

    this.filterFormValues.minutesTo
      ? (this.detailStorage.movementFilters.minutesTo = this.filterFormValues.minutesTo)
      : (this.detailStorage.movementFilters.minutesTo = '59');
  }

  printTkt(movimientoId: number) {
    if (this.isClover) {
      this.printCloverTicketService.openPrintTicketConfirmationPopup(movimientoId);
    } else {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        id: 1,
        info: 'Descargar comprobante',
        title: '¿Está seguro que desea descargar el comprobante?'
      };
      const dialogRef = this.dialog.open(ConfirmarDialogComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(async (response) => {
        if (response) {
          this.downloadLoading = true;
          this.paymentsService
            .downloadTicket(movimientoId)
            .then(() => {
              this.downloadLoading = false;
            })
            .catch(() => {
              this.downloadLoading = false;
            });
        } else {
          this.downloadLoading = false;
        }
      });
    }
  }

  isPixType(mpTipo: number): boolean {
    return mpTipo == 42;
  }

  showPrintButton(movementState: string, conceptoTipo: string, mp: any) {
    return (
      movementState !== estadoMovimiento.PENDIENTE &&
      conceptoTipo !== conceptoTipoEnum.DEPOSITO &&
      this.isTxBancaria(mp)
    );
  }

  isTxBancaria(mp: number) {
    if (this.cloverService.getTerminalId()) {
      return mp !== tipoMp.transferenciaBancaria;
    } else {
      return true;
    }
  }

  isRechazadoMovement(movementState: string) {
    return movementState == estadoMovimiento.RECHAZADO;
  }

  formatCPF(input: string) {
    const numbers = input.match(/\d/g)?.join('') || '';

    if (numbers.length !== 11) {
      return input;
    }

    const formattedNumbers = numbers.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    return input.replace(numbers, formattedNumbers);
  }

  formatPhone(input: string) {
    const numbers = input.match(/\d/g)?.join('') || '';

    if (numbers.length !== 13) {
      return input;
    }

    const formattedNumbers = numbers.replace(/(\d{2})(\d{2})(\d{4})(\d{5})/, '+$1 $2-$3-$4');
    return input.replace(numbers, formattedNumbers);
  }

  toggleFilter() {
    this.showOptions = !this.showOptions;
  }

  openCierreLotePopup() {
    let classes = [];
    this.cloverService.getTerminalId() ? classes.push('cierre-lote-450') : classes.push('cierre-lote-460');

    this.dialog.open(CierreLotePopupComponent, {
      panelClass: classes
    });
  }

  openDescargarLiquidacionPopup() {
    let classes = [];

    this.dialog.open(DescargarLiquidacionPopupComponent, {
      panelClass: classes
    });
  }
}

enum estadoMovimiento {
  ANULADO = 'Anulado',
  CONFIRMADO = 'Confirmado',
  APROBADO = 'Aprobado',
  ACREDITADO = 'Acreditado',
  PENDIENTE = 'Pendiente',
  RECHAZADO = 'Rechazado'
}

enum conceptoTipoEnum {
  BONIFICACION = 'B',
  COMISION_YACARE = 'C',
  RETENCION = 'I',
  DEVOLUCION = 'V',
  DEPOSITO = 'D',
  PAGO = 'P',
  RETIRO = 'R'
}

enum tipoMp {
  cajaPlus = 40,
  cuentaVirtualYacare = 99,
  visaCredito = 1,
  amexCredito = 2,
  visaDebito = 3,
  mastercardCredito = 4,
  maestroDebito = 5,
  mastercardDebito = 6,
  cabalDebito = 7,
  transferenciaBancaria = 30,
  cabalCredito = 8,
  mendozaActiva = 41,
  transferencia30 = 32
}

export interface FilterValues {
  paymentMethods: any[];
  paymentStates: any[];
  dateFrom: any;
  hourFrom: any;
  minutesFrom: any;
  dateTo: any;
  hourTo: any;
  minutesTo: any;
  branches: any[];
  cashiers: any[];
}
